import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { CustomerAdminMembersPageRoutingModule } from './customer-admin-members-routing.module';
import { CustomerAdminMembersPage } from './customer-admin-members.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxDatatableModule,
    NgxTippyModule,
    CustomerAdminMembersPageRoutingModule,
  ],
  declarations: [CustomerAdminMembersPage],
})
export class CustomerAdminMembersPageModule {}
